import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'ProcessingAgency/Create', method: 'POST', body: body, token: token })
}
